import { morphism } from 'morphism';

import { orderRequest } from '@hero/schemas';

import { api } from './api';
import { endpoints } from './endpoints';

const getOrderReport = params =>
  api
    .post(endpoints.generateOrderReport(), morphism(orderRequest.generateReport, params))
    .then(res => {
      return res?.data?.data;
    });
const getAutomationReport = (organizationCode, email, automationId) =>
  api.get(endpoints.getAutomationReport(organizationCode, email, automationId)).then(res => {
    return res?.data?.data;
  });

const getRecognitionReport = params =>
  api.get(endpoints.getRecognitionReport(), { params }).then(res => {
    return res?.data?.data;
  });

const getThankYouMessagesReport = params =>
  api
    .post(endpoints.generateThankYouMessagesReport(), morphism(orderRequest.generateReport, params))
    .then(res => {
      return res?.data?.data;
    });
const getRecognitionThankYouMessageReport = params =>
  api.get(endpoints.getRecognitionThankYouMessageReport(), { params }).then(res => {
    return res?.data?.data;
  });

const sendAutomationReport = body =>
  api.post(endpoints.sendAutomationReport, body).then(response => response.data.data);

const generateRecognitionReport = (params, body) =>
  api.post(endpoints.generateRecognitionReport(params), body).then(response => response.data.data);

const generateThankYouReport = body =>
  api.post(endpoints.generateThankYouReport, body).then(response => response.data.data);

export {
  generateRecognitionReport,
  generateThankYouReport,
  getAutomationReport,
  getOrderReport,
  getRecognitionReport,
  getRecognitionThankYouMessageReport,
  getThankYouMessagesReport,
  sendAutomationReport
};
